import { FDropdownItem, FSidebarItem } from "./types";

/**
 * Check if a link is active based on current URL path
 */
export const isLinkActive = (href: string, currentPath: string): boolean => {
  if (href === "/") {
    return currentPath === "/";
  }

  // Special case for campaign view URLs
  if (href === "/campaigns" && currentPath.includes("/campaign-view/")) {
    return true;
  }

  return currentPath.startsWith(href + "/") || currentPath === href;
};

/**
 * Determine if any menu item in a list is active based on current path
 */
export const hasActiveItem = (
  items: FSidebarItem[],
  currentPath: string
): boolean => {
  return items.some((item) => isLinkActive(item.href, currentPath));
};

/**
 * Handle menu item click with proper navigation
 */
export const handleMenuItemClick = (
  item: FDropdownItem | FSidebarItem,
  navigate?: (path: string) => void,
  closeMenu?: () => void
): void => {
  // Handle onClick callback if provided
  if (item.onClick) {
    item.onClick(item);
    if (closeMenu) closeMenu();
    return;
  }

  // Handle link navigation
  if ("link" in item && item.link) {
    // External link
    window.open(item.link, item.target || "_self");
    if (closeMenu) closeMenu();
  } else if ("href" in item && item.href && navigate) {
    // Internal navigation with react-router
    if (item.href.startsWith("http")) {
      window.open(item.href, "_blank");
    } else {
      navigate(item.href);
    }
    if (closeMenu) closeMenu();
  }
};
